"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignIn = void 0;
var components_1 = require("../../components");
var icons_1 = require("../../icons");
var react_1 = __importDefault(require("react"));
var SignIn = function (props) {
    var _a, _b;
    var menu = (react_1.default.createElement(components_1.Menu, null, props.items.map(function (item) {
        var _a, _b, _c;
        return (!item.hidden && (react_1.default.createElement(components_1.Menu.Item, { key: (_a = item.key) !== null && _a !== void 0 ? _a : item.text, className: (_b = item.className) !== null && _b !== void 0 ? _b : "" },
            react_1.default.createElement("a", { href: (_c = item.link) !== null && _c !== void 0 ? _c : "", onClick: item.onclick }, item.text))));
    })));
    var icon = (_a = props.icon) !== null && _a !== void 0 ? _a : react_1.default.createElement(icons_1.UserOutlined, null);
    var dropdownIcon = (_b = props.dropdownIcon) !== null && _b !== void 0 ? _b : react_1.default.createElement(icons_1.CaretDownFilled, null);
    return !props.visible ? null : (react_1.default.createElement("div", { hidden: !props.visible, className: "sign-in" },
        react_1.default.createElement(components_1.Dropdown, { trigger: ["click"], overlay: menu },
            react_1.default.createElement(components_1.Button, { type: "primary" },
                icon,
                dropdownIcon))));
};
exports.SignIn = SignIn;
exports.default = exports.SignIn;
//# sourceMappingURL=index.js.map